import {combineReducers} from "redux";
import {reducer as configReducer} from "./config/reducer";

export default combineReducers({
  config: configReducer
});
